export default __webpack_public_path__ + "static/media/birth-spacing@2x.3eae7c08.png";